goog.require('el8.template.multiuser_access.passwordQA');
goog.require('el8.service.urls');
goog.require('el8.util.base');
goog.require('el8.uiwidget.Form');

var el8 = el8 || {};
if(!el8.multiuser_access) { el8.multiuser_access = {}; }

el8.multiuser_access.passwordQA = (function() {

    var that = {};

    var numWrongAnswer = 0;
    var userProfileId = null;
    var questionId = null;
    var faxCode = null;
    var theForm = null;

    function submitAnswer() {
        // submit the answer to the server
        var userAnswer = theForm.getVal('answer');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('submitAnswer', [faxCode, userProfileId, questionId]),
            data: JSON.stringify({
                answer: userAnswer
            }),
            async: true,
            success: function(data) {
                if (data.password_reset_token) {
                    location.href=el8.service.urls.get('pageResetPassword', [faxCode, userProfileId, data.password_reset_token]);
                } else {

                    $('.incorrect-answer').show();
                    numWrongAnswer++;
                    if (numWrongAnswer >= 3) {
                        location.href=el8.service.urls.get('pageForgotAnswerAutoDetect', [faxCode, userProfileId]);
                    }
                }
            }
        });
    }

    function inputChanged() {
        $('.el8ErrorAlert').fadeOut();
       if (theForm.getVal('answer')) {
           $('#submit').prop('disabled', false);
       } else {
           $('#submit').prop('disabled', true);
       }
    }

    var debouncedInputChanged = _.debounce(inputChanged, 250);

    function setupKeyPressedListeners() {
        $(document).on('keykpress', ':input[name="answer"]', debouncedInputChanged);
    }

    that.init = function(spec) {
        /**
         * Initialize the global URL service
         */

        if (spec.urls) { el8.service.urls.init(spec.urls); }
        var question = spec.question;
        questionId = spec.questionId;
        userProfileId = spec.userProfileId;
        faxCode = spec.faxCode;

        $('.main-content').html(
            el8.template.multiuser_access.passwordQA.content({
                question: question,
                forgotAnswerUrl: el8.service.urls.get('pageForgotAnswer', [faxCode, userProfileId])
            })
        );

        theForm = new el8.uiwidget.Form({
            fields: [{
                name: 'answer',
                selector: ':input[name="answer"]',
                maxLength: 100,
                changeFn: function() {
                    inputChanged();
                }
            }],
            container: $('#main-form')
        });
        theForm.render();
        inputChanged();
        $('.el8ErrorAlert').hide();
        setupKeyPressedListeners();
        $(document).on('click', '#submit', function(event) {
            submitAnswer();
        });
    };

    return that;

})();